import React, { useState } from 'react'
import Main from '../../cpn/Main'
import { Tabs } from 'antd'
import StatisticProfitDept from './StatisticProfitDept'
import StatisticProfitOp from './StatisticProfitOp'
import StatisticProfitClient from './StatisticProfitClient'
import StatisticProfitUid from './StatisticProfitUid'
import { ApartmentOutlined, UserOutlined, SkinOutlined, UserAddOutlined } from '@ant-design/icons'
function StatisticProfit(props) {
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-caiwu_statistic_profit_active_key') || '0')
    return (
        <Main 
        selectedKeys='/StatisticProfit' qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} 
        yh_qx={props.yh_qx}
        loanNeedApproveNum={props.loanNeedApproveNum}
        loanNeedReadNum={props.loanNeedReadNum}
        loanRejectedNum={props.loanRejectedNum}
        loanEndNeedReadNum={props.loanEndNeedReadNum}
        reportRejectedNum={props.reportRejectedNum}
        reportNeedApproveNum={props.reportNeedApproveNum}
        reportNeedReadNum={props.reportNeedReadNum}
        expenseNeedApproveNum={props.expenseNeedApproveNum}
        expenseNeedReadNum={props.expenseNeedReadNum}
        expenseRejectedNum={props.expenseRejectedNum}
        expenseEndNeedReadNum={props.expenseEndNeedReadNum}
        ddzcNeedApproveNum={props.ddzcNeedApproveNum}
        ddzcNeedReadNum={props.ddzcNeedReadNum}
        ddzcRejectedNum={props.ddzcRejectedNum}
        ddzcEndNeedReadNum={props.ddzcEndNeedReadNum}
        ddsrNeedApproveNum={props.ddsrNeedApproveNum}
        ddsrNeedReadNum={props.ddsrNeedReadNum}
        ddsrRejectedNum={props.ddsrRejectedNum}
        ddsrEndNeedReadNum={props.ddsrEndNeedReadNum}
        invoiceNeedApproveNum={props.invoiceNeedApproveNum}
        invoiceNeedReadNum={props.invoiceNeedReadNum}
        invoiceRejectedNum={props.invoiceRejectedNum}
        invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
        >
            <Tabs
                items={[
                    {
                        key: '0',
                        label: '部门',
                        children: <StatisticProfitDept qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} spjdList={props.spjdList} />,
                        icon: <ApartmentOutlined />,
                    },
                    {
                        key: '1',
                        label: '计调',
                        children: <StatisticProfitOp qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} spjdList={props.spjdList} />,
                        icon: <UserOutlined />,
                    },
                    {
                        key: '2',
                        label: '客户',
                        children: <StatisticProfitClient qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} spjdList={props.spjdList} />,
                        icon: <SkinOutlined />,
                    },
                    {
                        key: '3',
                        label: '操作员',
                        children: <StatisticProfitUid qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} spjdList={props.spjdList} />,
                        icon: <UserAddOutlined />,
                    },
                ]}
                activeKey={activeKey}
                onChange={(key) => {
                    setActiveKey(key)
                    localStorage.setItem('jtg-caiwu_statistic_profit_active_key', key)
                }}
            />
        </Main>
    )
}

export default StatisticProfit